import { Avatar, FormControl, FormHelperText, Grid, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import Masks from '../../providers/Masks';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import avatar from '../../Pics/avatar.jpg'
import DetaliiConcediiAngajat from '../../commons/dialogs/DetaliiConcediiAngajat';
import ConcediuDialogNew from '../../commons/dialogs/ConcediuDialogNew'
import LocalStorage from '../../providers/LocalStorage';
import id from 'date-fns/esm/locale/id/index.js';
import AlertNew from '../../commons/dialogs/AlertNew';
import FoaieColectiva from './FoaieColectiva';




export default class PontajTabel extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listDaysOfWeek:
                [
                    {
                        id: 7,
                        name: 'D',
                        date: '',
                        selectedDay: false,
                        color: 'white',
                        backgroundColor: '#FF7575',
                        pontajList: []
                    },
                    {
                        id: 1,
                        name: 'L',
                        date: '',
                        selectedDay: false,
                        color: 'rgb(171 171 171)',
                        backgroundColor: '#FBFBFB',
                        pontajList: []
                    },
                    {
                        id: 2,
                        name: 'M',
                        date: '',
                        selectedDay: false,
                        color: 'rgb(171 171 171)',
                        backgroundColor: '#FBFBFB',
                        pontajList: []
                    },
                    {
                        id: 3,
                        name: 'M',
                        date: '',
                        selectedDay: false,
                        color: 'rgb(171 171 171)',
                        backgroundColor: '#FBFBFB',
                        pontajList: []
                    },
                    {
                        id: 4,
                        name: 'J',
                        date: '',
                        selectedDay: false,
                        color: 'rgb(171 171 171)',
                        backgroundColor: '#FBFBFB',
                        pontajList: []
                    },
                    {
                        id: 5,
                        name: 'V',
                        date: '',
                        selectedDay: false,
                        color: 'rgb(171 171 171)',
                        backgroundColor: '#FBFBFB',
                        pontajList: []
                    },
                    {
                        id: 6,
                        name: 'S',
                        date: '',
                        selectedDay: false,
                        color: 'white',
                        backgroundColor: '#FF7575',
                        pontajList: []
                    }


                ],

            dataStart: this.m.fistDayMonth(new Date()),
            dataEnd: this.m.lastDayMonth(new Date()),
            tipConcedii: this.u.tipConcedii,
            zileAngajati: [],
            departamentDisabled: false,
            departamente: [],
            departament: -1,
            isOpenAngajatPontaje: false,
            eveniment: {},
            dataInceput: this.u.defaultData(),
            dataSfarsit: this.m.fistDayMonth(new Date()),
            openInsertEveniment: false,
            openUpdateEveniment: false,
            angajat: { id: '', nume: '' },
            pontajeDrepturi: {},
            eveniment: {},
            dataEveniment: this.m.fistDayMonth(new Date()),
            tipConcediu: 'prezent',
            tipuriConcedii: this.u.tipConcedii,
            existaPontaj: false,
            oraInceput: '00:00',
            oraFinalizare: '00:00',
            alertConcediuTitlu: '',
            alertConcediuMesaj: '',
            openAlertConcediu: false,
            openAlertProgram: false,
            listaAngajati: [],
            foaieColectiva:false,
            pontajeAll:[],
            concedii:[]




        }

    }

    componentDidMount() {

        this.getData()

    }

    angajati = []
    concedii = []
    pontaje = []

    ws = new Ws()
    u = new Utils()
    m = new Masks()
    ls = new LocalStorage()


    getData = async (dep = null) => {

        let userData = this.ls.GetUserData()

        console.log('userData :>> ', userData);
        //select * from angajati where data_angajarii <= '${this.state.dataEnd}' and isnull(data_plecarii , '2999-01-01') > '${this.state.dataStart}'

        // select a.id, a.nume,a.functie, a.poza, a.cv, a.id_user, ad.id_departament from angajati a left join angajati_departamente ad on a.id = ad.id_angajat where isnull(a.inactiv,0) != @p1 and isnull(ad.inactiv,0) !=@p1 group by a.id, a.nume, a.poza, a.cv, a.id_user, ad.id_departament, a.functie

        let pontajeDrepturi = await this.ws.customSelect(`select d.*, a.*, u.* from angajati_departamente d left join 
                                                 angajati a on a.id = d.id_angajat left join useri u on u.id = a.id_user where u.id = @p1 and isnull(u.inactiv, 0) != 1`, {
            p1: this.ls.GetUserData().InfoUser.IdUser
        })


        let _angajati;
        let _departamente;




        if (userData.InfoUser.IsAdmin === 1) {
            _angajati = this.ws.customSelect(`select a.*, ad.id_departament from angajati a left join angajati_departamente ad
            on a.id = ad.id_angajat where a.data_angajarii <= '${this.state.dataEnd}' and isnull(a.data_plecarii , '2999-01-01') > '${this.state.dataStart}' and isnull(a.inactiv,0) != 1 `, {
                p1: this.state.dataEnd,
                p2: this.state.dataStart
            })

            _departamente = this.ws.customSelect(`select * from departamente where isnull(inactiv,0) != 1`, {
                p1: 1
            })

        } else if (pontajeDrepturi.Succes) {
            if (pontajeDrepturi.Content.length > 0) {
                let angajatDrepturi = { ...pontajeDrepturi.Content[0] }

                console.log('angajatDrepturi :>> ', angajatDrepturi);

                if (angajatDrepturi.sef_departament === 1) {
                    _angajati = this.ws.customSelect(`select a.*, ad.id_departament from angajati a left join angajati_departamente ad
                    on a.id = ad.id_angajat where a.data_angajarii <= '${this.state.dataEnd}' and isnull(a.data_plecarii , '2999-01-01') > '${this.state.dataStart}' and isnull(a.inactiv,0) != 1 and ad.id_departament = @p3 `, {
                        p1: this.state.dataEnd,
                        p2: this.state.dataStart,
                        p3: angajatDrepturi.id_departament
                    })

                    _departamente = this.ws.customSelect(`select * from departamente where isnull(inactiv,0) != 1 and id = @p1`, {
                        p1: angajatDrepturi.id_departament,

                    })
                } else {
                    _angajati = this.ws.customSelect(`select a.*, ad.id_departament from angajati a left join angajati_departamente ad
                    on a.id = ad.id_angajat where a.data_angajarii <= '${this.state.dataEnd}' and isnull(a.data_plecarii , '2999-01-01') > '${this.state.dataStart}' and isnull(a.inactiv,0) != 1 and a.id = @p3 `, {
                        p1: this.state.dataEnd,
                        p2: this.state.dataStart,
                        p3: angajatDrepturi.id_angajat
                    })

                    _departamente = this.ws.customSelect(`select * from departamente where isnull(inactiv,0) != 1 and id = @p1`, {
                        p1: angajatDrepturi.id_departament,

                    })
                }


                let angajatTest = await this.ws.customSelect('select * from angajati where id = @p1',{
                    p1: angajatDrepturi.id_angajat
                })
        
                console.log('angajatTest :>> ', angajatTest);
            }

          

        }









        let _concedii = this.ws.customSelect(`select c.*, p.id_angajat from concedii c left outer join pontaje p on p.id_concediu = c.id
        where year(c.cand_inceput_data) = year(@p1) OR year(c.cand_sfarsit_data) = year(@p1) and isnull(p.sters,0) != 1 ` , {
            p1: this.state.dataStart,
            p2: this.state.dataEnd
        })
        // let _concedii = this.ws.customSelect('select * from concedii where 1 = @p1',{p1:1})

        let _pontaje = this.ws.customSelect(`select * from pontaje where year(la_data) = year(@p1) and isnull(sters,0) != 1`, {
            p1: this.state.dataStart
        })

        let _program = this.ws.customSelect(`select * from program_lucru where 1 = 1`, {
            p1: this.state.angajat.id
        })

        // let insertPontaj = await this.ws.insert('pontaje',{id_angajat:3, la_data:'2021-07-12'})
        // let updatePontaj = await this.ws.update('pontaje', {id_concediu:2}, {id:7})
        // let insertConcediu = await this.ws.update('concedii',{id_angajat:3}, {id:2})

        // console.log('insertConcediu :>> ', insertConcediu);




        let [angajati, concedii, pontaje, d, pr] = await Promise.all([_angajati, _concedii, _pontaje, _departamente, _program])

        console.log('angajati :>> ', angajati);
        console.log('concedii :>> ', concedii);
        console.log('pontaje :>> ', pontaje);
        console.log('d :>> ', d);
        console.log('pr :>> ', pr);

        if (angajati.Succes && concedii.Succes && pontaje.Succes && d.Succes && pr.Succes) {



            this.angajati = angajati.Content
            this.concedii = concedii.Content
            let program = [...pr.Content]
            this.pontaje = pontaje.Content


            let departamente = [...d.Content]


            for (let i = 0, n = this.pontaje.length; i < n; i++) {

                let idx = this.concedii.findIndex(c => c.id === this.pontaje[i].id_concediu)
                // console.log('idx :', idx);

                if (idx !== -1) {
                    this.pontaje[i].cand_inceput_dataC = this.concedii[idx].cand_inceput_data
                    this.pontaje[i].cand_sfarsit_dataC = this.concedii[idx].cand_sfarsit_data
                    this.pontaje[i].tip_concediu = this.concedii[idx].tip_concediu
                    this.pontaje[i].cand_inceput_oraC = null
                    this.pontaje[i].cand_sfarsit_oraC = null

                    let idxConcediu = this.u.tipConcedii.findIndex(tp => tp.id === this.concedii[idx].tip_concediu)

                    if (idxConcediu !== -1) {
                        this.pontaje[i].nume_concediu = this.u.tipConcedii[idxConcediu].nume
                    }

                } else if (this.pontaje[i].tip === 'absenta_invoire') {



                    this.pontaje[i].tip_concediu = 'absenta_invoire'
                    this.pontaje[i].cand_inceput_oraC = this.pontaje[i].cand_inceput_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_inceput_ora) : '08:00'
                    this.pontaje[i].cand_sfarsit_oraC = this.pontaje[i].cand_sfarsit_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_sfarsit_ora) : '18:00'

                    console.warn('this.pontaje[i] :>> ', this.pontaje[i]);
                } else if (this.pontaje[i].tip === 'invoire') {
                    this.pontaje[i].tip_concediu = 'invoire'
                    this.pontaje[i].cand_inceput_oraC = this.pontaje[i].cand_inceput_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_inceput_ora) : '08:00'
                    this.pontaje[i].cand_sfarsit_oraC = this.pontaje[i].cand_sfarsit_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_sfarsit_ora) : '18:00'
                } else if (this.pontaje[i].tip === 'ore_suplimentare') {

                    this.pontaje[i].tip_concediu = 'ore_suplimentare'
                    this.pontaje[i].cand_inceput_oraC = this.pontaje[i].cand_inceput_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_inceput_ora) : '08:00'
                    this.pontaje[i].cand_sfarsit_oraC = this.pontaje[i].cand_sfarsit_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_sfarsit_ora) : '18:00'
                    this.pontaje[i].prezent_azi = this.pontaje[i].prezent_azi ? this.pontaje[i].prezent_azi : 0
                }

                else {




                    this.pontaje[i].tip_concediu = this.dictionary.pontaje.prezentProgramNormal
                    this.pontaje[i].cand_inceput_oraC = this.pontaje[i].cand_inceput_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_inceput_ora) : '08:00'
                    this.pontaje[i].cand_sfarsit_oraC = this.pontaje[i].cand_sfarsit_ora ? this.u.transformTimeFromSql(this.pontaje[i].cand_sfarsit_ora) : '18:00'
                    this.pontaje[i].prezent_azi = this.pontaje[i].prezent_azi ? this.pontaje[i].prezent_azi : 0


                    //todo Programul Angajatului inclus in pontaj
                }
            }



            for (let i = 0, n = this.angajati.length; i < n; i++) {

                this.angajati[i].zile_libere = []

                let idxDep = departamente.findIndex(d => Number(d.id) === Number(this.angajati[i].id_departament))

                console.log('idxDep :>> ', idxDep);

                if (idxDep !== -1) {

                    let idx = program.findIndex(p => p.id_angajat === this.angajati[i].id)

                    this.angajati[i].program = []


                    if (idx !== -1) {

                        if (this.u.transformTimeFromSql(program[idx].du_start) === '00:00') {
                            this.angajati[i].zile_libere.push(0)
                        } else {
                            this.angajati[i].program.push({
                                start: idx !== -1 ? this.u.transformTimeFromSql(program[idx].du_start) : '00:00'
                                , end: idx !== -1 ? this.u.transformTimeFromSql(program[idx].du_end) : '18:00',
                                dateIdx: 0
                            })


                        }

                        if (this.u.transformTimeFromSql(program[idx].lu_start) === '00:00') {
                            this.angajati[i].zile_libere.push(1)
                        } else {

                            this.angajati[i].program.push({
                                start: idx !== -1 ? this.u.transformTimeFromSql(program[idx].lu_start) : '00:00'
                                , end: idx !== -1 ? this.u.transformTimeFromSql(program[idx].lu_end) : '18:00',
                                dateIdx: 1
                            })


                        }

                        if (this.u.transformTimeFromSql(program[idx].ma_start) === '00:00') {
                            this.angajati[i].zile_libere.push(2)
                        } else {

                            this.angajati[i].program.push({
                                start: idx !== -1 ? this.u.transformTimeFromSql(program[idx].ma_start) : '00:00'
                                , end: idx !== -1 ? this.u.transformTimeFromSql(program[idx].ma_end) : '18:00',
                                dateIdx: 2
                            })

                        }

                        if (this.u.transformTimeFromSql(program[idx].mi_start) === '00:00') {
                            this.angajati[i].zile_libere.push(3)
                        } else {

                            this.angajati[i].program.push({
                                start: idx !== -1 ? this.u.transformTimeFromSql(program[idx].mi_start) : '00:00'
                                , end: idx !== -1 ? this.u.transformTimeFromSql(program[idx].mi_end) : '18:00',
                                dateIdx: 3
                            })

                        }

                        if (this.u.transformTimeFromSql(program[idx].jo_start) === '00:00') {
                            this.angajati[i].zile_libere.push(4)
                        } else {

                            this.angajati[i].program.push({
                                start: idx !== -1 ? this.u.transformTimeFromSql(program[idx].jo_start) : '00:00'
                                , end: idx !== -1 ? this.u.transformTimeFromSql(program[idx].jo_end) : '18:00',
                                dateIdx: 4
                            })

                        }

                        if (this.u.transformTimeFromSql(program[idx].vi_start) === '00:00') {
                            this.angajati[i].zile_libere.push(5)
                        } else {

                            this.angajati[i].program.push({
                                start: idx !== -1 ? this.u.transformTimeFromSql(program[idx].vi_start) : '00:00'
                                , end: idx !== -1 ? this.u.transformTimeFromSql(program[idx].vi_end) : '18:00',
                                dateIdx: 5
                            })

                        }

                        if (this.u.transformTimeFromSql(program[idx].sa_start) === '00:00') {
                            this.angajati[i].zile_libere.push(6)
                        } else {

                            this.angajati[i].program.push({
                                start: idx !== -1 ? this.u.transformTimeFromSql(program[idx].sa_start) : '00:00'
                                , end: idx !== -1 ? this.u.transformTimeFromSql(program[idx].sa_end) : '18:00',
                                dateIdx: 6
                            })

                        }


                    }


                    this.angajati[i]['nume_departament'] = departamente[idxDep].nume
                }else{
                    let idx = program.findIndex(p => p.id_angajat === this.angajati[i].id)

                    this.angajati[i].program = []


                    if (idx !== -1) {

                        if (this.u.transformTimeFromSql(program[idx].du_start) === '00:00') {
                            this.angajati[i].zile_libere.push(0)
                        } else {
                            this.angajati[i].program.push({
                                start: idx !== -1 ? this.u.transformTimeFromSql(program[idx].du_start) : '00:00'
                                , end: idx !== -1 ? this.u.transformTimeFromSql(program[idx].du_end) : '18:00',
                                dateIdx: 0
                            })


                        }

                        if (this.u.transformTimeFromSql(program[idx].lu_start) === '00:00') {
                            this.angajati[i].zile_libere.push(1)
                        } else {

                            this.angajati[i].program.push({
                                start: idx !== -1 ? this.u.transformTimeFromSql(program[idx].lu_start) : '00:00'
                                , end: idx !== -1 ? this.u.transformTimeFromSql(program[idx].lu_end) : '18:00',
                                dateIdx: 1
                            })


                        }

                        if (this.u.transformTimeFromSql(program[idx].ma_start) === '00:00') {
                            this.angajati[i].zile_libere.push(2)
                        } else {

                            this.angajati[i].program.push({
                                start: idx !== -1 ? this.u.transformTimeFromSql(program[idx].ma_start) : '00:00'
                                , end: idx !== -1 ? this.u.transformTimeFromSql(program[idx].ma_end) : '18:00',
                                dateIdx: 2
                            })

                        }

                        if (this.u.transformTimeFromSql(program[idx].mi_start) === '00:00') {
                            this.angajati[i].zile_libere.push(3)
                        } else {

                            this.angajati[i].program.push({
                                start: idx !== -1 ? this.u.transformTimeFromSql(program[idx].mi_start) : '00:00'
                                , end: idx !== -1 ? this.u.transformTimeFromSql(program[idx].mi_end) : '18:00',
                                dateIdx: 3
                            })

                        }

                        if (this.u.transformTimeFromSql(program[idx].jo_start) === '00:00') {
                            this.angajati[i].zile_libere.push(4)
                        } else {

                            this.angajati[i].program.push({
                                start: idx !== -1 ? this.u.transformTimeFromSql(program[idx].jo_start) : '00:00'
                                , end: idx !== -1 ? this.u.transformTimeFromSql(program[idx].jo_end) : '18:00',
                                dateIdx: 4
                            })

                        }

                        if (this.u.transformTimeFromSql(program[idx].vi_start) === '00:00') {
                            this.angajati[i].zile_libere.push(5)
                        } else {

                            this.angajati[i].program.push({
                                start: idx !== -1 ? this.u.transformTimeFromSql(program[idx].vi_start) : '00:00'
                                , end: idx !== -1 ? this.u.transformTimeFromSql(program[idx].vi_end) : '18:00',
                                dateIdx: 5
                            })

                        }

                        if (this.u.transformTimeFromSql(program[idx].sa_start) === '00:00') {
                            this.angajati[i].zile_libere.push(6)
                        } else {

                            this.angajati[i].program.push({
                                start: idx !== -1 ? this.u.transformTimeFromSql(program[idx].sa_start) : '00:00'
                                , end: idx !== -1 ? this.u.transformTimeFromSql(program[idx].sa_end) : '18:00',
                                dateIdx: 6
                            })

                        }


                    }
                }


                this.angajati[i]['zile_concediu_ramase'] = this.angajati[i]['nr_zile_concediu'] || 21

                console.log('this.angajati[i] :>> ', this.angajati[i]);

                let concediiAng = this.pontaje.filter(p => p.id_angajat === this.angajati[i]['id'])

                let concediiFilter = concediiAng.filter(c => c.tip_concediu === 'concediu_odihna')

                console.log('concediiFilter :>> ', concediiFilter);

                // console.log('concediiFilter :>> ', concediiFilter);

                // console.log('concediiAng :>> ', concediiAng);

                for (let j = 0, m = concediiFilter.length; j < m; j++) {

                    // let dayDiff = this.u.getDaysDifference(concediiFilter[j].cand_inceput_dataC, concediiFilter[j].cand_sfarsit_dataC)
                    let dayDiff = this.u.dayDiffConcediu(concediiFilter[j].cand_inceput_dataC, concediiFilter[j].cand_sfarsit_dataC, this.angajati[i].program)
                    console.log('dayDiff :>> ', dayDiff);



                    this.angajati[i]['zile_concediu_ramase'] = this.angajati[i]['zile_concediu_ramase'] - dayDiff

                    // console.log('this.angajati[i] :>> ', this.angajati[i]);


                }
            }



            console.warn('this.angajati :>> ', this.angajati);

            console.warn('pontaje Drepturi', pontajeDrepturi)


            if (dep) {
                this.angajati = this.angajati.filter(aa => Number(aa.id_departament) === Number(dep))
            }

            console.warn('this.state.departament :>> ', this.state.departament);
            console.warn('departamente', departamente)

            this.setState({
                departamente: departamente,
                listaAngajati: this.angajati,
                pontaje: this.pontaje,
                pontajeAll:this.pontaje,
                concedii: this.concedii,
                pontajeDrepturi: pontajeDrepturi.Content.length > 0 ? pontajeDrepturi.Content[0] : { sef_departament: 0, is_admin: 0 }
            }, () => {

                this.generateLista()
            })

        }
    }


    changeDepartament = async (ev) => {

        let val = ev.target.value

        console.log('val :>> ', val);
        this.setState({ departament: val }, async () => {

            if (Number(val) === -1) {
                this.getData()
            } else {
                this.getData(val)
            }

        })
    }


    generateLista = () => {

        // tipConcedii = [
        //     {id:'absenta_nemotivata', nume:'Absenta Nemotivat', bkColor:'rgb(227 51	59)', color:'white'},
        //     { id: 'concediu_fara_plata', nume: 'C. Fara Plata', bkColor: 'rgb(250 113 117)', color: 'white', alias: 'CFP' },
        //     { id: 'concediu_odihna', nume: 'C. Odihna', bkColor: 'rgba(38	120	227	)', color: 'white', alias: 'CO' },
        //     { id: 'concediu_medical', nume: 'C. Medical, Accident, Boala Profesionala, Carantina', bkColor: 'rgb(252 99	7)', color: 'white', alias: 'CM' },
        //     { id: 'concediu_ingrijire_copil', nume: 'C. Maternitate, Paternitate, Crestere Copil, Ingrijire Copil', bkColor: 'rgb(241 23 168)', color: 'white', alias: 'CI' },
        //     { id: 'evenimente_speciale', nume: 'C. Evenimente Deosebite', bkColor: 'rgb(238	231	24)', color: 'white', alias: 'ES' },
        //     { id: 'preaviz', nume: 'C. Acomodare, C. Preaviz', bkColor: 'rgb(21	164	191)', color: 'white', alias: 'PR' },
        //     // { id: 'absenta_invoire', nume: 'Absenta Invoire', bkColor: 'rgb(206, 152, 79)', color: 'white', alias: 'AI' },

        //     // { id: 'ore_suplimentare', nume: 'Ore Suplimentare', bkColor: '#135FB7', color: 'white' },

        // ]

        let listaZile = this.u.generateListaZile(new Date(this.state.dataStart), new Date(this.state.dataEnd))

        // console.log('listaZile :>> ', listaZile);
        // console.log('angajati :>> ', this.angajati);
        // console.log('concedii :>> ', this.concedii);
        // console.log('pontaje :>> ', this.pontaje);

        let zileAngajati = []

        for (let i = 0, n = this.angajati.length; i < n; i++) {

            let angajatToReturn = this.angajati[i]

            let zileAngajat = {
                id: this.angajati[i].id,
                nume: this.angajati[i].nume,
                functie: this.angajati[i].functie,
                departament: this.angajati[i].nume_departament,
                nr_zile_concediu: this.angajati[i].nr_zile_concediu ? this.angajati[i].nr_zile_concediu : 21,
                zile_libere: this.angajati[i].zile_libere,
                poza: this.angajati[i].poza,
                zileAngajat: [],
                program: this.angajati[i].program,
                zile_concediu_ramase: this.angajati[i]['zile_concediu_ramase']
            }

        
            for (let j = 0, m = listaZile.length; j < m; j++) {

                let idxProgram = this.angajati[i].zile_libere.findIndex(p => p === new Date(listaZile[j]).getDay())

                // console.log('idxProgram :>> ', idxProgram);

                let ziAngajat = {}

                if (idxProgram === -1) {

                    ziAngajat = {
                        zi: this.m.specificDateToDateField(listaZile[j]),
                        ziua: new Date(listaZile[j]).getDate(),
                        ziLuna: new Date(listaZile[j]).getMonth() + 1,
                        prezent: this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id && this.m.datesAreEgual(this.m.sqlDateToJSDate(pp.la_data), listaZile[j]) === true && pp.prezent_azi === 1 && pp.tip_concediu !== 'ore_suplimentare').length > 0,
                        absent: this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id && this.m.datesAreEgual(this.m.sqlDateToJSDate(pp.la_data), listaZile[j]) === true && pp.absent_azi === 1).length > 0,
                        absenta_invoire: this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id && this.m.datesAreEgual(this.m.sqlDateToJSDate(pp.la_data), listaZile[j]) === true && pp.tip === 'absenta_invoire').length > 0,
                        invoire: this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id && this.m.datesAreEgual(this.m.sqlDateToJSDate(pp.la_data), listaZile[j]) === true && pp.tip === 'invoire').length > 0,
                        ore_suplimentare: this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id && this.m.datesAreEgual(this.m.sqlDateToJSDate(pp.la_data), listaZile[j]) === true && pp.tip === 'ore_suplimentare').length > 0,
                        concediuFP: this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id &&
                            (this.u.compareDate(listaZile[j], pp.cand_inceput_dataC) && this.u.compareDate(pp.cand_sfarsit_dataC, listaZile[j])) === true &&
                            pp.tip_concediu === 'concediu_fara_plata').length > 0,
                        concediuO: this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id &&
                            (this.u.compareDate(listaZile[j], pp.cand_inceput_dataC) && this.u.compareDate(pp.cand_sfarsit_dataC, listaZile[j])) === true &&
                            pp.tip_concediu === 'concediu_odihna').length > 0,
                        concediuM: this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id &&
                            (this.u.compareDate(listaZile[j], pp.cand_inceput_dataC) && this.u.compareDate(pp.cand_sfarsit_dataC, listaZile[j])) === true &&
                            pp.tip_concediu === 'concediu_medical').length > 0,
                        concediuIC: this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id &&
                            (this.u.compareDate(listaZile[j], pp.cand_inceput_dataC) && this.u.compareDate(pp.cand_sfarsit_dataC, listaZile[j])) === true &&
                            pp.tip_concediu === 'concediu_ingrijire_copil').length > 0,
                        evSpeciale: this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id &&
                            (this.u.compareDate(listaZile[j], pp.cand_inceput_dataC) && this.u.compareDate(pp.cand_sfarsit_dataC, listaZile[j])) === true &&
                            pp.tip_concediu === 'evenimente_speciale').length > 0,
                        preaviz: this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id &&
                            (this.u.compareDate(listaZile[j], pp.cand_inceput_dataC) && this.u.compareDate(pp.cand_sfarsit_dataC, listaZile[j])) === true &&
                            pp.tip_concediu === 'preaviz').length > 0,
                        color: '',
                        eveniment: {}

                    }

                } else {

                    ziAngajat = {
                        zi: this.m.specificDateToDateField(listaZile[j]),
                        ziua: new Date(listaZile[j]).getDate(),
                        ziLuna: new Date(listaZile[j]).getMonth() + 1,
                        prezent: false,
                        absent: false,
                        ore_suplimentare: this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id && this.m.datesAreEgual(this.m.sqlDateToJSDate(pp.la_data), listaZile[j]) === true && pp.tip === 'ore_suplimentare').length > 0,
                        concediuFP: false,
                        concediuO: false,
                        concediuM: false,
                        concediuIC: false,
                        evSpeciale: false,
                        preaviz: false,
                        color: '',
                        eveniment: {}

                    }

                }



                // console.log('ziAngajat :>> ', ziAngajat);


                let color = ''

                if (ziAngajat.prezent) {
                    ziAngajat.eveniment = this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id && this.m.datesAreEgual(this.m.sqlDateToJSDate(pp.la_data), listaZile[j]) === true && pp.prezent_azi === 1 && pp.tip_concediu !== 'ore_suplimentare').length > 0 ? this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id && this.m.datesAreEgual(this.m.sqlDateToJSDate(pp.la_data), listaZile[j]) === true && pp.prezent_azi === 1 && pp.tip_concediu !== 'ore_suplimentare' )[0] : null
                    ziAngajat.eveniment.nume_concediu = this.dictionary.pontaje.prezent
                    color = 'rgb(135 226 167)'
                } else if (ziAngajat.absent) {
                    ziAngajat.eveniment = this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id && this.m.datesAreEgual(this.m.sqlDateToJSDate(pp.la_data), listaZile[j]) === true && pp.absent_azi === 1)[0]
                    color = 'rgb(227 51	59)'
                    ziAngajat.eveniment.nume_concediu =  this.dictionary.pontaje.absentaNemotivata
                } else if (ziAngajat.absenta_invoire) {
                    ziAngajat.eveniment = this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id && this.m.datesAreEgual(this.m.sqlDateToJSDate(pp.la_data), listaZile[j]) === true && pp.tip === 'absenta_invoire')[0]
                    color = 'rgb(206, 152, 79)'
                    ziAngajat.eveniment.nume_concediu =  this.dictionary.pontaje.absentaInvoire
                } else if (ziAngajat.invoire) {
                    ziAngajat.eveniment = this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id && this.m.datesAreEgual(this.m.sqlDateToJSDate(pp.la_data), listaZile[j]) === true && pp.tip === 'invoire')[0]
                    color = 'rgb(112 227 255)'
                    ziAngajat.eveniment.nume_concediu = this.dictionary.pontaje.invoireFaraAbsenta
                } else if (ziAngajat.ore_suplimentare) {
                    ziAngajat.eveniment = this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id && this.m.datesAreEgual(this.m.sqlDateToJSDate(pp.la_data), listaZile[j]) === true && pp.tip === 'ore_suplimentare')[0]
                    color = 'rgb(14 111 28)'
                    ziAngajat.eveniment.nume_concediu =  this.dictionary.pontaje.oreSuplimentare
                } else if (ziAngajat.concediuFP) {
                    ziAngajat.eveniment = this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id &&
                        (this.u.compareDate(listaZile[j], pp.cand_inceput_dataC) && this.u.compareDate(pp.cand_sfarsit_dataC, listaZile[j])) === true &&
                        pp.tip_concediu === 'concediu_fara_plata')[0]
                    color = 'rgb(250 113 117)'
                    ziAngajat.eveniment.nume_concediu =  this.dictionary.pontaje.cFaraPlata
                } else if (ziAngajat.concediuO) {
                    ziAngajat.eveniment = this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id &&
                        (this.u.compareDate(listaZile[j], pp.cand_inceput_dataC) && this.u.compareDate(pp.cand_sfarsit_dataC, listaZile[j])) === true &&
                        pp.tip_concediu === 'concediu_odihna')[0]
                    color = 'rgba(38 120 227)'
                    ziAngajat.eveniment.nume_concediu =  this.dictionary.pontaje.cOdihna
                } else if (ziAngajat.concediuM) {
                    ziAngajat.eveniment = this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id &&
                        (this.u.compareDate(listaZile[j], pp.cand_inceput_dataC) && this.u.compareDate(pp.cand_sfarsit_dataC, listaZile[j])) === true &&
                        pp.tip_concediu === 'concediu_medical')[0]
                    color = 'rgb(252 99	7)'
                    ziAngajat.eveniment.nume_concediu =  this.dictionary.pontaje.cMedicalAccident
                } else if (ziAngajat.concediuIC) {
                    ziAngajat.eveniment = this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id &&
                        (this.u.compareDate(listaZile[j], pp.cand_inceput_dataC) && this.u.compareDate(pp.cand_sfarsit_dataC, listaZile[j])) === true &&
                        pp.tip_concediu === 'concediu_ingrijire_copil')[0]
                    color = 'rgb(241 23 168)'
                    ziAngajat.eveniment.nume_concediu =  this.dictionary.pontaje.cMaternitate
                } else if (ziAngajat.evSpeciale) {
                    ziAngajat.eveniment = this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id &&
                        (this.u.compareDate(listaZile[j], pp.cand_inceput_dataC) && this.u.compareDate(pp.cand_sfarsit_dataC, listaZile[j])) === true &&
                        pp.tip_concediu === 'evenimente_speciale')[0]
                    color = 'rgb(238 231 24)'
                    ziAngajat.eveniment.nume_concediu =  this.dictionary.pontaje.cEvenimenteSpeciale
                } else if (ziAngajat.preaviz) {
                    ziAngajat.eveniment = this.pontaje.filter(pp => pp.id_angajat === this.angajati[i].id &&
                        (this.u.compareDate(listaZile[j], pp.cand_inceput_dataC) && this.u.compareDate(pp.cand_sfarsit_dataC, listaZile[j])) === true &&
                        pp.tip_concediu === 'preaviz')[0]
                    color = 'rgb(21	164	191)'
                    ziAngajat.eveniment.nume_concediu =  this.dictionary.pontaje.cAcomodare
                } else {
                    color = 'transparent'
                }

                ziAngajat.color = color

                if (ziAngajat.eveniment) {
                    ziAngajat.eveniment.color = color
                }


                zileAngajat.zileAngajat.push(ziAngajat)

            }

   

            zileAngajati.push(zileAngajat)


        }
        console.log('prezent :>> ', zileAngajati);

        this.setState({ zileAngajati: zileAngajati })
    }




    numeLuna = (l) => {

        // console.log('l :', l);
        let rez = ''

        switch (l) {
            case 1: rez = this.dictionary.luni.ianuarie; break;
            case 2: rez = this.dictionary.luni.februarie; break;
            case 3: rez = this.dictionary.luni.martie; break;
            case 4: rez = this.dictionary.luni.aprilie; break;
            case 5: rez = this.dictionary.luni.mai; break;
            case 6: rez = this.dictionary.luni.iunie; break;
            case 7: rez = this.dictionary.luni.iulie; break;
            case 8: rez = this.dictionary.luni.august; break;
            case 9: rez = this.dictionary.luni.septembrie; break;
            case 10: rez = this.dictionary.luni.octombrie; break;
            case 11: rez = this.dictionary.luni.noiembrie; break;
            case 12: rez = this.dictionary.luni.decembrie; break;

        }

        return rez
    }

    minusLuna = () => {

        let dataStart = this.state.dataStart

        let dataEnd = this.state.dataEnd


        dataStart = new Date(this.state.dataStart).setMonth(new Date(this.state.dataStart).getMonth() - 1)
        dataEnd = new Date(this.state.dataEnd).setMonth(new Date(this.state.dataEnd).getMonth() - 1)

        dataStart = new Date(dataStart)
        dataEnd = new Date(dataEnd)

        // console.log('dataStart :>> ', dataStart);
        // console.log('dataEnd :>> ', dataEnd);

        this.setState({
            dataStart: this.m.fistDayMonth(dataStart),
            dataEnd: this.m.lastDayMonth(dataStart)
        }, () => {
            this.getData()
        })
    }


    plusLuna = () => {
        let dataStart = this.state.dataStart

        let dataEnd = this.state.dataEnd


        dataStart = new Date(this.state.dataStart).setMonth(new Date(this.state.dataStart).getMonth() + 1)
        dataEnd = new Date(this.state.dataEnd).setMonth(new Date(this.state.dataEnd).getMonth() + 1)

        dataStart = new Date(dataStart)
        dataEnd = new Date(dataEnd)

        this.setState({
            dataStart: this.m.fistDayMonth(dataStart),
            dataEnd: this.m.lastDayMonth(dataStart)
        }, () => {
            this.getData()
        })
    }


    numeAvatar = (nume) => {

        if (nume) {
            let n = nume.split(' ')

            // console.log('n :>> ', n);

            let firstLetters = ''

            if (n[0]) {

                firstLetters += n[0].substring(0, 1)

            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }

            firstLetters = firstLetters.toUpperCase()

            return firstLetters
        } else {
            return 'NA'
        }


    }



    afisareTabel = () => {
        // if (this.state.zileAngajati.length > 0) {

        let tableHead = []

        let tH = []

        let table = []

        let tBody = []


        let zileAngajati = [...this.state.zileAngajati]

        let listaZile = this.u.generateListaZile(new Date(this.state.dataStart), new Date(this.state.dataEnd))

        for (let i = 0, n = listaZile.length; i < n; i++) {

            tH.push(<th style={{ backgroundColor: this.state.listDaysOfWeek[new Date(listaZile[i]).getDay()].backgroundColor, color: this.state.listDaysOfWeek[new Date(listaZile[i]).getDay()].color, textAlign: 'center', fontSize:14, fontWeight:400 }} key={`th${i}`}>{this.state.listDaysOfWeek[new Date(listaZile[i]).getDay()].name} </th>)
        }


        for (let i = 0, n = zileAngajati.length; i < n; i++) {


            let tr = []

            for (let j = 0, m = zileAngajati[i].zileAngajat.length; j < m; j++) {

                tr.push(<td
                    onClick={() => { this.openAdaugaEvenimentNou(zileAngajati[i].zileAngajat[j], zileAngajati[i]) }}
                    style={{ backgroundColor: this.state.listDaysOfWeek[new Date(zileAngajati[i].zileAngajat[j].zi).getDay()].id < 6 ? '#FBFBFB' : '#ECECEC', color: 'rgb(171 171 171)', textAlign: 'center', cursor: 'pointer', position: 'relative' }} key={`td${zileAngajati[i].id}${zileAngajati[i].zileAngajat[j].ziua}${j}`}>
                    <span style={{fontWeight: 400, fontSize:14}}>{j + 1}</span>
                    <div >

                        <span><div style={{
                            backgroundColor: zileAngajati[i].zileAngajat[j].color,
                            width: zileAngajati[i].zileAngajat[j].prezent ? 5 : 10,
                            height: zileAngajati[i].zileAngajat[j].prezent ? 5 : 10,
                            borderRadius: '50%',
                            margin: 'auto',
                            marginTop: 5
                        }}></div></span>


                    </div>

                    {this.m.datesAreEgual(new Date(this.u.defaultData()), new Date(zileAngajati[i].zileAngajat[j].zi)) && <div style={{
                        height: 4,
                        width: '100%',
                        backgroundColor: 'rgb(62	138	230)',
                        position: 'absolute',
                        bottom: 0
                    }}></div>}
                </td>)
            }
            tBody.push(
                <tr key={`tr${zileAngajati[i].id}`}>
                    <td style={{ padding: '5px 0 5px 0 ' }} colSpan={7} >

                        <Grid onClick={() => { this.openDetaliiAngajat(zileAngajati[i]) }} container>

                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                {
                                    zileAngajati[i].poza &&
                                    <div
                                        className='pm-angajati-picture'

                                        style={{ backgroundImage: `url('${zileAngajati[i].poza ? (new Ws().adresaMedia + '/Angajati/' + zileAngajati[i].poza) : avatar}')`, width: 36, height: 36, padding: 5 }}>

                                    </div>
                                }
                                {!zileAngajati[i].poza &&

                                    <Avatar
                                        className='pm-angajati-picture'
                                        style={{ display: 'flex', textAlign: 'center', justifyContent: 'center', height: 28, width: 28, backgroundColor: new Utils().culoriUtilizatori(zileAngajati[i].id), padding: 5, cursor: 'pointer' }}>
                                        {/* <i style={{ verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }} className='material-icons'>person</i> */}
                                        <span style={{ display: 'block' }}>{this.numeAvatar(zileAngajati[i].nume)} </span>
                                    </Avatar>
                                    // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                }
                            </Grid>

                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>
                                <span style={{ fontWeight: 400, fontSize: 14 }}>    {zileAngajati[i].nume}</span><br />
                                <span style={{
                                    fontSize: 12,
                                    color: '#9a9a9a'
                                }}>{zileAngajati[i].functie} - {zileAngajati[i].departament}</span>
                            </Grid>

                        </Grid>

                        {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                            // onClick={()=>{this.selectFile(`file${s.id}`)}}
                            onClick={() => { this.props.openDetaliiAngajat(angajati[i]) }}
                            className='pm-angajati-picture'
                            style={{ backgroundImage: `url('${angajati[i].poza ? (new Ws().adresaMedia + '/Angajati/' + angajati[i].poza) : avatar}')` }}>

                        </div>



                        <span
                            style={{
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                width: 130,
                                display: 'inline-block',
                                whiteSpace: 'nowrap'

                            }}
                            className='pm-title'>
                            {angajati[i].nume}
                        </span>

                    </div> */}
                    </td>
                    {tr}
                </tr>
            )




            let trSpacer = (
                <tr key={`spacer${i}`} style={{ height: 10 }}>

                </tr>
            )

            tBody.push(trSpacer)
        }

        tableHead = (
            <thead>
                <tr >
                    <th style={{ position: 'sticky', top: 0, zIndex: 1 }} colSpan={7}>
                        <div style={{ position: 'relative' }}>

                            <FormControl variant="outlined" style={{ width: '100%' }}>
                                {/* <InputLabel id="demo-simple-select-outlined-label">Age</InputLabel> */}
                                <Select
                                    style={{ fontSize: 14 }}
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    className='demo-simple-select'
                                    value={this.state.departament || ""}
                                    onChange={(ev) => { this.changeDepartament(ev) }}
                                    // label="Age"
                                    placeholder={this.dictionary.pontaje.departamentCautaLucrator}
                                >
                                    <MenuItem style={{ padding: 10 }} value={-1}>
                                        {this.dictionary.pontaje.toate}
                                    </MenuItem>
                                    {this.state.departamente.map((s, idx) => {
                                        return (
                                            <MenuItem style={{ padding: 10 }} key={idx} value={s.id}>{s.nume}</MenuItem>
                                        )
                                    })}
                                </Select>

                            </FormControl>


                            {/* <select
                                id='departament'
                                style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                className='add-project-input'
                                type="text"
                                margin="normal"
                                name='tva'
                                // disabled={this.state.departamentDisabled !== 1 ? true : false}
                                value={this.state.departament || ""}
                                onChange={(ev) => { this.changeDepartament(ev) }}
                                placeholder={this.dictionary.pontaje.departamentCautaLucrator}
                            >

                                <option value={-1}>{this.dictionary.pontaje.toate}</option>
                                {this.state.departamente.map((s, idx) => {
                                    return (
                                        <option key={idx} value={s.id}>{s.nume}</option>
                                    )
                                })}
                            </select> */}
                            {/* <label className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.evaluari.selecteaza}</label> */}
                        </div>

                    </th>
                    {tH}
                </tr>
                <tr style={{ height: 10 }}>

                </tr>
            </thead>
        )

        // table = (

        // )

        // console.log('tH :>> ', tH);

        table = (
            <div className='scrolltable' style={{ marginBottom: 50 }}>

                <table style={{
                    width: '100%',
                    minWidth: 1200,
                    maxWidth: 1300,
                    margin: '20px auto',
                    marginBottom: 0,
                    tableLayout: 'fixed',
                    borderCollapse: 'collapse',
                    backgroundColor: 'white',
                    position: 'relative',
                    fontSize: 12
                }}>
                    {tableHead}</table>
                <div className='body'>

                    <table style={{
                        width: '100%',
                        minWidth: 1200,
                        maxWidth: 1300,
                        margin: '0 auto',
                        tableLayout: 'fixed',
                        borderCollapse: 'collapse',
                        backgroundColor: 'white',
                        position: 'relative',
                        fontSize: 12
                    }}>
                        <tbody>{tBody}</tbody>
                    </table>



                </div>
            </div>
        )

        return table


        // }
    }

    openDetaliiAngajat = (a) => {
        console.log('a :>> ', a);
        console.log('this.state.pontajeDrepturi :>> ', this.state.pontajeDrepturi);

        this.setState({
            isOpenAngajatPontaje: true,
            angajatSelectat: a
        })
    }


    goToEveniment = (eveniment) => {

        console.log('eveniment :>> ', eveniment);
        // this.setState({
        //     openUpdateEveniment: true,
        //     eveniment: eveniment,
        //     dataInceput: this.u.ParseDataFromSql(eveniment.cand_inceput_dataC),
        //     dataSfarsit: this.u.ParseDataFromSql(eveniment.cand_sfarsit_dataC),
        // })
    }


    openAdaugaEvenimentNou = (eveniment, angajat) => {

        console.log('e :>> ', eveniment);
        // console.log('ziAngajat :>> ', ziAngajat);

        if (eveniment.eveniment.la_data) {

            console.log('eveniment.tip :>> ', eveniment.eveniment);
            this.setState({
                openUpdateEveniment: true,
                angajat: angajat,
                eveniment: eveniment.eveniment,
                dataInceput: eveniment.eveniment.cand_inceput_dataC ? this.u.ParseDataFromSql(eveniment.eveniment.cand_inceput_dataC) : this.u.ParseDataFromSql(eveniment.eveniment.la_data),
                dataSfarsit: this.u.ParseDataFromSql(eveniment.eveniment.cand_sfarsit_dataC),
                dataEveniment: eveniment.zi,
                tipConcediu: eveniment.eveniment.tip_concediu


            }, () => {
                console.log('tipConcediu :>> ', this.state.tipConcediu);
                console.log('this.state.dataInceput :>> ', this.state.dataInceput);
            })


        } else {
            this.setState({
                dataEveniment: eveniment.zi,
                angajat: angajat,
                openInsertEveniment: true,
                dataInceput: eveniment.zi,
                dataSfarsit: eveniment.zi,
                eveniment: { la_data: this.u.defaultData(), tip_concediu: '', prezenta: null, }
            })

            console.log('insert :>> ',);
        }


    }


    adaugaEvenimentNou = async () => {

        let _pontaje = this.ws.customSelect(`select * from pontaje where year(la_data) = year(@p1) and isnull(sters,0) != 1 and id_angajat = @p2`, {
            p1: this.state.dataInceput,
            p2: this.state.angajat.id
        })

        let _concedii = this.ws.customSelect(`select c.*, p.id_angajat from concedii c left outer join pontaje p on p.id_concediu = c.id
        where year(c.cand_inceput_data) = year(@p1) OR year(c.cand_sfarsit_data) = year(@p1) and isnull(p.sters,0) != 1  and p.id_angajat = @p3` , {
            p1: this.state.dataInceput,
            p2: this.state.dataSfarsit,
            p3: this.state.angajat.id
        })


console.log('this.state.tipConcediu :>> ', this.state.tipConcediu);

        let [p, c] = await Promise.all([_pontaje, _concedii])

        if (p.Succes && c.Succes) {

            let pontaje = [...p.Content]

            let concedii = [...c.Content]




            let existaPontaj = false




            console.log('existaPontaj :>> ', existaPontaj);




            if (this.state.tipConcediu === 'prezent') {



                let dataPontaj = new Date(this.state.dataInceput)

                console.log('this.staet.angajat :>> ', this.state.angajat);


                if (this.state.angajat.program.length > 0) {
                    
                    let inceputOraPontaj;
                    let sfarsitOraPontaj
                    console.log('getDay :>> ', dataPontaj.getDay());
                    console.log('this.state.angajat.program :>> ', this.state.angajat.program);

                    let idxDay = this.state.angajat.program.findIndex(pr => pr.dateIdx === dataPontaj.getDay())

                    if (idxDay !== -1) {
                        inceputOraPontaj = this.state.angajat.program[idxDay].start ? this.state.angajat.program[idxDay].start : '08:00'
                        sfarsitOraPontaj = this.state.angajat.program[idxDay].end ? this.state.angajat.program[idxDay].end : '18:00'
                        


                        let pontajToInsert = {


                            id_angajat: this.state.angajat.id,
                            id_cine_pontat: this.ls.GetUserData().InfoUser.IdUser,
                            la_data: this.state.dataInceput,
                            prezent_azi: 1,
                            cand_pontat: this.u.updateSqlNow(),
                            cand_inceput_ora: inceputOraPontaj,
                            cand_sfarsit_ora: sfarsitOraPontaj


                        }

                        for (let i = 0, n = pontaje.length; i < n; i++) {

                            // console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                            // console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                            existaPontaj = this.m.datesAreEgual(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput))

                            if (existaPontaj) {

                                let update = await this.ws.update('pontaje', { prezent_azi: 1, absent_azi: 0, absent_motivatie: 0 }, { id: pontaje[i].id })

                                if (update.Succes) {

                                    this.setState({
                                        openInsertEveniment: false,
                                        dataInceput: this.u.defaultData(),
                                        dataSfarsit: this.u.defaultData(),
                                        tipConcediu: 'prezent',
                                        oraInceput: '00:00',
                                        oraFinalizare: '00:00',
                                        existaPontaj: ''
                                    }, () => {
                                        this.getData()
                                    })

                                    break;

                                }


                            }
                        }


                        if (!existaPontaj) {
                            let insertPontaj = await this.ws.insert('pontaje', pontajToInsert)

                            if (insertPontaj.Succes) {
                                this.setState({
                                    openInsertEveniment: false,
                                    dataInceput: this.u.defaultData(),
                                    dataSfarsit: this.u.defaultData(),
                                    tipConcediu: 'prezent',
                                    oraInceput: '00:00',
                                    oraFinalizare: '00:00',
                                    existaPontaj: ''
                                }, () => {
                                    this.getData()
                                })


                            }
                        }
                    } else {
                        let pontajToInsert = {


                            id_angajat: this.state.angajat.id,
                            id_cine_pontat: this.ls.GetUserData().InfoUser.IdUser,
                            la_data: this.state.dataInceput,
                            tip: 'ore_suplimentare',
                            prezent_azi: 1,
                            cand_inceput_ora: '08:00',
                            cand_sfarsit_ora: '18:00',
                            cand_pontat: this.u.defaultData()
        
                        }
        
                        for (let i = 0, n = pontaje.length; i < n; i++) {
        
                            console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                            console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                            existaPontaj = this.m.datesAreEgual(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput))
        
                            if (existaPontaj) {
        
                                let update = await this.ws.update('pontaje', { prezent_azi: 1, absent_azi: 0, absent_motivatie: 0, tip: this.state.tipConcediu }, { id: pontaje[i].id })
        
                                if (update.Succes) {
        
                                    this.setState({
                                        openInsertEveniment: false,
                                        dataInceput: this.u.defaultData(),
                                        dataSfarsit: this.u.defaultData(),
                                        tipConcediu: 'prezent',
                                        oraInceput: '00:00',
                                        oraFinalizare: '00:00',
                                        existaPontaj: ''
                                    }, () => {
                                        this.getData()
                                    })
        
                                    break;
        
                                }
        
        
                            }
                        }
        
        
                        if (!existaPontaj) {
                            let insertPontaj = await this.ws.insert('pontaje', pontajToInsert)
        
                            if (insertPontaj.Succes) {
                                this.setState({
                                    openInsertEveniment: false,
                                    dataInceput: this.u.defaultData(),
                                    dataSfarsit: this.u.defaultData(),
                                    tipConcediu: 'prezent',
                                    oraInceput: '00:00',
                                    oraFinalizare: '00:00',
                                    existaPontaj: ''
                                }, () => {
                                    this.getData()
                                })
        
        
                            }
                        }
                    }












                } else {
                    let pontajToInsert = {


                        id_angajat: this.state.angajat.id,
                        id_cine_pontat: this.ls.GetUserData().InfoUser.IdUser,
                        la_data: this.state.dataInceput,
                        tip: 'ore_suplimentare',
                        prezent_azi: 1,
                        cand_inceput_ora: '08:00',
                        cand_sfarsit_ora: '18:00',
                        cand_pontat: this.u.defaultData()
    
                    }
    
                    for (let i = 0, n = pontaje.length; i < n; i++) {
    
                        console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                        console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                        existaPontaj = this.m.datesAreEgual(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput))
    
                        if (existaPontaj) {
    
                            let update = await this.ws.update('pontaje', { prezent_azi: 1, absent_azi: 0, absent_motivatie: 0, tip: this.state.tipConcediu }, { id: pontaje[i].id })
    
                            if (update.Succes) {
    
                                this.setState({
                                    openInsertEveniment: false,
                                    dataInceput: this.u.defaultData(),
                                    dataSfarsit: this.u.defaultData(),
                                    tipConcediu: 'prezent',
                                    oraInceput: '00:00',
                                    oraFinalizare: '00:00',
                                    existaPontaj: ''
                                }, () => {
                                    this.getData()
                                })
    
                                break;
    
                            }
    
    
                        }
                    }
    
    
                    if (!existaPontaj) {
                        let insertPontaj = await this.ws.insert('pontaje', pontajToInsert)
    
                        if (insertPontaj.Succes) {
                            this.setState({
                                openInsertEveniment: false,
                                dataInceput: this.u.defaultData(),
                                dataSfarsit: this.u.defaultData(),
                                tipConcediu: 'prezent',
                                oraInceput: '00:00',
                                oraFinalizare: '00:00',
                                existaPontaj: ''
                            }, () => {
                                this.getData()
                            })
    
    
                        }
                    }
                }




            } else if (this.state.tipConcediu === 'absenta_nemotivata') {
                let pontajToInsert = {


                    id_angajat: this.state.angajat.id,
                    id_cine_pontat: this.ls.GetUserData().InfoUser.IdUser,
                    la_data: this.state.dataInceput,
                    absent_azi: 1,
                    cand_pontat: this.u.defaultData(),
                    prezent_azi:0

                }


                console.log('pontajToInsert :>> ', pontajToInsert);

                for (let i = 0, n = pontaje.length; i < n; i++) {

                    console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                    console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                    existaPontaj = this.m.datesAreEgual(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput))

                    if (existaPontaj) {

                        let update = await this.ws.update('pontaje', { prezent_azi: 0, absent_azi: 1, absent_motivatie: 0 }, { id: pontaje[i].id })

                        if (update.Succes) {

                            this.setState({
                                openInsertEveniment: false,
                                dataInceput: this.u.defaultData(),
                                dataSfarsit: this.u.defaultData(),
                                tipConcediu: 'prezent',
                                oraInceput: '00:00',
                                oraFinalizare: '00:00',
                                existaPontaj: ''
                            }, () => {
                                this.getData()
                            })

                            break;

                        }


                    }
                }


                if (!existaPontaj) {
                    let insertPontaj = await this.ws.insert('pontaje', pontajToInsert)

                    if (insertPontaj.Succes) {
                        this.setState({
                            openInsertEveniment: false,
                            dataInceput: this.u.defaultData(),
                            dataSfarsit: this.u.defaultData(),
                            tipConcediu: 'prezent',
                            oraInceput: '00:00',
                            oraFinalizare: '00:00',
                            existaPontaj: ''
                        }, () => {
                            this.getData()
                        })


                    }
                }
            } else if (this.state.tipConcediu === 'absenta_invoire') {


                let pontajToInsert = {


                    id_angajat: this.state.angajat.id,
                    id_cine_pontat: this.ls.GetUserData().InfoUser.IdUser,
                    la_data: this.state.dataInceput,
                    tip: this.state.tipConcediu,
                    // prezent_azi: 1,
                    cand_inceput_ora: this.state.oraInceput,
                    cand_sfarsit_ora: this.state.oraFinalizare,
                    cand_pontat: this.u.defaultData()

                }


                console.log('pontajToInsert :>> ', pontajToInsert);

                for (let i = 0, n = pontaje.length; i < n; i++) {

                    console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                    console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                    existaPontaj = this.m.datesAreEgual(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput))

                    if (existaPontaj) {

                        let update = await this.ws.update('pontaje', { prezent_azi: 0, absent_azi: 0, absent_motivatie: 0, tip: this.state.tipConcediu }, { id: pontaje[i].id })

                        if (update.Succes) {

                            this.setState({
                                openInsertEveniment: false,
                                dataInceput: this.u.defaultData(),
                                dataSfarsit: this.u.defaultData(),
                                tipConcediu: 'prezent',
                                oraInceput: '00:00',
                                oraFinalizare: '00:00',
                                existaPontaj: ''
                            }, () => {
                                this.getData()
                            })

                            break;

                        }


                    }
                }


                if (!existaPontaj) {
                    let insertPontaj = await this.ws.insert('pontaje', pontajToInsert)

                    if (insertPontaj.Succes) {
                        this.setState({
                            openInsertEveniment: false,
                            dataInceput: this.u.defaultData(),
                            dataSfarsit: this.u.defaultData(),
                            tipConcediu: this.state.tipConcediu,
                            oraInceput: '00:00',
                            oraFinalizare: '00:00',
                            existaPontaj: ''
                        }, () => {
                            this.getData()
                        })


                    }
                }

            } else if (this.state.tipConcediu === 'invoire') {

                let pontajToInsert = {


                    id_angajat: this.state.angajat.id,
                    id_cine_pontat: this.ls.GetUserData().InfoUser.IdUser,
                    la_data: this.state.dataInceput,
                    tip: this.state.tipConcediu,
                    // prezent_azi: 1,
                    cand_inceput_ora: this.state.oraInceput,
                    cand_sfarsit_ora: this.state.oraFinalizare,
                    cand_pontat: this.u.defaultData()

                }

                console.log('pontajToInsert :>> ', pontajToInsert);

                for (let i = 0, n = pontaje.length; i < n; i++) {

                    console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                    console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                    existaPontaj = this.m.datesAreEgual(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput))

                    if (existaPontaj) {

                        let update = await this.ws.update('pontaje', { prezent_azi: 0, absent_azi: 0, absent_motivatie: 0, tip: this.state.tipConcediu }, { id: pontaje[i].id })

                        if (update.Succes) {

                            this.setState({
                                openInsertEveniment: false,
                                dataInceput: this.u.defaultData(),
                                dataSfarsit: this.u.defaultData(),
                                tipConcediu: this.state.tipConcediu,
                                oraInceput: '00:00',
                                oraFinalizare: '00:00',
                                existaPontaj: ''
                            }, () => {
                                this.getData()
                            })

                            break;

                        }


                    }
                }


                if (!existaPontaj) {
                    let insertPontaj = await this.ws.insert('pontaje', pontajToInsert)

                    if (insertPontaj.Succes) {
                        this.setState({
                            openInsertEveniment: false,
                            dataInceput: this.u.defaultData(),
                            dataSfarsit: this.u.defaultData(),
                            tipConcediu: 'prezent',
                            oraInceput: '00:00',
                            oraFinalizare: '00:00',
                            existaPontaj: ''
                        }, () => {
                            this.getData()
                        })


                    }
                }

            } else if (this.state.tipConcediu === 'ore_suplimentare') {

                let pontajToInsert = {


                    id_angajat: this.state.angajat.id,
                    id_cine_pontat: this.ls.GetUserData().InfoUser.IdUser,
                    la_data: this.state.dataInceput,
                    tip: this.state.tipConcediu,
                    prezent_azi: 1,
                    cand_inceput_ora: this.state.oraInceput,
                    cand_sfarsit_ora: this.state.oraFinalizare,
                    cand_pontat: this.u.defaultData()

                }

                for (let i = 0, n = pontaje.length; i < n; i++) {

                    console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                    console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                    existaPontaj = this.m.datesAreEgual(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput))

                    if (existaPontaj) {

                        let update = await this.ws.update('pontaje', { prezent_azi: 1, absent_azi: 0, absent_motivatie: 0, tip: this.state.tipConcediu }, { id: pontaje[i].id })

                        if (update.Succes) {

                            this.setState({
                                openInsertEveniment: false,
                                dataInceput: this.u.defaultData(),
                                dataSfarsit: this.u.defaultData(),
                                tipConcediu: 'prezent',
                                oraInceput: '00:00',
                                oraFinalizare: '00:00',
                                existaPontaj: ''
                            }, () => {
                                this.getData()
                            })

                            break;

                        }


                    }
                }


                if (!existaPontaj) {
                    let insertPontaj = await this.ws.insert('pontaje', pontajToInsert)

                    if (insertPontaj.Succes) {
                        this.setState({
                            openInsertEveniment: false,
                            dataInceput: this.u.defaultData(),
                            dataSfarsit: this.u.defaultData(),
                            tipConcediu: 'prezent',
                            oraInceput: '00:00',
                            oraFinalizare: '00:00',
                            existaPontaj: ''
                        }, () => {
                            this.getData()
                        })


                    }
                }

            }


            else {
                let concediuToAdd = {
                    cand_inceput_data: this.state.dataInceput,
                    cand_sfarsit_data: this.state.dataSfarsit,
                    tip_concediu: this.state.tipConcediu
                }


                let permisConcediu = true
                if (concediuToAdd['tip_concediu'] === 'concediu_odihna') {

                    console.log('this.state.angajat :>> ', this.state.angajat);

                    let programAngajat = this.state.angajat.program
                   let dayDiff = this.u.dayDiffConcediu(this.state.dataInceput, this.state.dataSfarsit,programAngajat)

                    console.log('dayDiff :>> ', dayDiff);

                    if (Number(dayDiff) > Number(this.state.angajat['zile_concediu_ramase'])) {
                        permisConcediu = false
                    }

                }

                console.log('permisConcediu :>> ', permisConcediu);

                if (permisConcediu) {
                    for (let i = 0, n = pontaje.length; i < n; i++) {

                        console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                        console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                        existaPontaj = (this.u.compareDate(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput)) && this.u.compareDate(new Date(this.state.dataSfarsit), this.m.sqlDateToJSDate(pontaje[i].la_data)))

                        if (existaPontaj) {

                            let update = await this.ws.update('pontaje', { prezent_azi: 0, absent_azi: 0, absent_motivatie: 0 }, { id: pontaje[i].id })

                            if (update.Succes) {



                            }


                        }
                    }





                    let insertConcediu = await this.ws.insert('concedii', concediuToAdd)

                    if (insertConcediu.Succes) {


                        let insertPontaj = await this.ws.insert('pontaje', {
                            id_angajat: this.state.angajat.id,
                            id_cine_pontat: this.ls.GetUserData().InfoUser.IdUser,
                            la_data: this.state.dataInceput,
                            id_concediu: insertConcediu.Content[0].id
                        })

                        if (insertPontaj.Succes) {
                            this.setState({
                                openInsertEveniment: false,
                                dataInceput: this.u.defaultData(),
                                dataSfarsit: this.u.defaultData(),
                                tipConcediu: 'prezent',
                                oraInceput: '00:00',
                                oraFinalizare: '00:00',
                                existaPontaj: ''
                            }, () => {
                                this.getData()
                            })

                        }


                    }

                } else {

                    console.log('permisConcediu :>> ', permisConcediu);
                    this.setState({
                        openAlertConcediu: true,
                        alertConcediuTitlu: `Numar zile de concediu depasit!`,
                        alertConcediuMesaj: `Mai aveti ${this.state.angajat['zile_concediu_ramase']} de zile de concediu pentru acest utilizator.`
                    })

                }





            }



        }

    }

    updateEveniment = async () => {


        console.log(' :>> ',);

        let _pontaje = await this.ws.customSelect(`select * from pontaje where year(la_data) = year(@p1) and isnull(sters,0) != 1 and id_angajat = @p2`, {
            p1: this.state.dataStart,
            p2: this.state.angajat.id
        })

        if (_pontaje.Succes) {

            let pontaje = [..._pontaje.Content]

            let existaPontaj = false

            for (let i = 0, n = pontaje.length; i < n; i++) {

                console.log('this.m.sqlDateToJSDate(p[i].la_data) :>> ', this.m.sqlDateToJSDate(pontaje[i].la_data));
                console.log('new Date(this.state.dataInceput) :>> ', new Date(this.state.dataInceput));
                existaPontaj = (this.u.compareDate(this.m.sqlDateToJSDate(pontaje[i].la_data), new Date(this.state.dataInceput)) && this.u.compareDate(new Date(this.state.dataSfarsit), this.m.sqlDateToJSDate(pontaje[i].la_data)))

                if (existaPontaj) {

                    let update = await this.ws.update('pontaje', { prezent_azi: 0, absent_azi: 0, absent_motivatie: 0 }, { id: pontaje[i].id })

                    if (update.Succes) {



                    }


                }
            }

            let updateConcediu = await this.ws.update('concedii',
                {
                    cand_inceput_data: this.state.dataInceput,
                    cand_sfarsit_data: this.state.dataSfarsit,
                },
                { id: this.state.eveniment.id_concediu })

            if (updateConcediu.Succes) {
                this.setState({
                    eveniment: { la_data: this.u.defaultData(), tip_concediu: '', prezenta: null, id_concediu: '', },
                    openUpdateEveniment: false,
                    dataInceput: this.u.defaultData(),
                    dataSfarsit: this.u.defaultData(),
                    tipConcediu: 'prezent',
                    oraInceput: '00:00',
                    oraFinalizare: '00:00',
                    existaPontaj: '',
                    angajat: { nume: '', id: '' }
                }, () => {
                    this.getData()
                })
            }

        }








    }

    stergeEveniment = async (eveniment) => {

        let stergeEveniment = await this.ws.update('pontaje',
            {
                sters: 1
            },
            { id: eveniment.id })

        if (stergeEveniment.Succes) {

            this.setState({
                eveniment: { la_data: this.u.defaultData(), tip_concediu: '', prezenta: null, id_concediu: '', },
                openUpdateEveniment: false,
                dataInceput: this.u.defaultData(),
                dataSfarsit: this.u.defaultData(),
                tipConcediu: 'prezent',
                oraInceput: '00:00',
                oraFinalizare: '00:00',
                existaPontaj: ''
            }, () => {
                this.getData()
            })
        }
    }


    render() {
        return (
            <div>

                <AlertNew
                    open={this.state.openAlertConcediu}
                    dialogClose={() => { this.setState({ openAlertConcediu: false }) }}
                    title={this.state.alertConcediuTitlu}
                    mesaj={this.state.alertConcediuMesaj}
                    noButtonDisplay={1}
                    yesFunction={() => { this.setState({ openAlertConcediu: false }) }}
                />

                <AlertNew
                    open={this.state.openAlertProgram}
                    dialogClose={() => { this.setState({ openAlertProgram: false }) }}
                    title={this.dictionary.pontaje.nuExistaProgram}
                    mesaj={this.dictionary.pontaje.vaRugamAdaugatiProgram}
                    noButtonDisplay={1}
                    yesFunction={() => { this.setState({ openAlertProgram: false }) }}
                />
                {this.state.isOpenAngajatPontaje &&

                    <DetaliiConcediiAngajat
                        open={this.state.isOpenAngajatPontaje}
                        dialogClose={() => { this.setState({ isOpenAngajatPontaje: false }, () => { this.getData() }) }}
                        angajat={this.state.angajatSelectat}
                        dataStart={this.state.dataStart}
                        dataEnd={this.state.dataEnd}
                        history={this.props.history}
                        pontajDrepturi={this.state.pontajeDrepturi}
                        openAlertConcediu={(p) => { this.setState(p) }}

                    />
                }

                <ConcediuDialogNew
                    open={this.state.openInsertEveniment}
                    dialogClose={() => { this.setState({ openInsertEveniment: false }) }}
                    angajat={this.state.angajat}
                    eveniment={this.state.eveniment}
                    dataInceput={this.state.dataInceput}
                    changeDataInceput={(ev) => { this.setState({ dataInceput: ev.target.value }) }}
                    dataSfarsit={this.state.dataSfarsit}
                    changeDataSfarsit={(ev) => { this.setState({ dataSfarsit: ev.target.value }) }}
                    tipEveniment={this.state.tipConcediu}
                    tipuriConcedii={this.state.tipuriConcedii}
                    changeTip={(ev) => { this.setState({ tipConcediu: ev.target.value }) }}
                    adaugaEvenimentNou={this.adaugaEvenimentNou}
                    oraInceput={this.state.oraInceput}
                    changeOraInceput={(ev) => { this.setState({ oraInceput: ev.target.value }) }}
                    oraFinalizare={this.state.oraFinalizare}
                    changeOraFinalizare={(ev) => { this.setState({ oraFinalizare: ev.target.value }) }}
                    existaPontaj={this.state.existaPontaj}
                    pontajDrepturi={this.state.pontajeDrepturi}
                />

                <ConcediuDialogNew
                    open={this.state.openUpdateEveniment}
                    dialogClose={() => { this.setState({ openUpdateEveniment: false }) }}
                    angajat={this.state.angajat}
                    eveniment={this.state.eveniment}
                    dataInceput={this.state.dataInceput}
                    changeDataInceput={(ev) => { this.setState({ dataInceput: ev.target.value }) }}
                    dataSfarsit={this.state.dataSfarsit}
                    changeDataSfarsit={(ev) => { this.setState({ dataSfarsit: ev.target.value }) }}
                    tipEveniment={this.state.tipConcediu}
                    tipuriConcedii={this.state.tipuriConcedii}
                    changeTip={(ev) => { this.setState({ tipConcediu: ev.target.value }) }}
                    adaugaEvenimentNou={this.updateEveniment}
                    oraInceput={this.state.oraInceput}
                    changeOraInceput={(ev) => { this.setState({ oraInceput: ev.target.value }) }}
                    oraFinalizare={this.state.oraFinalizare}
                    changeOraFinalizare={(ev) => { this.setState({ oraFinalizare: ev.target.value }) }}
                    existaPontaj={this.state.existaPontaj}
                    toUpdate={true}
                    stergeEveniment={this.stergeEveniment}
                    pontajDrepturi={this.state.pontajeDrepturi}
                />


                {!this.props.foaieColectiva &&
                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>



                                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20, fontSize:18, fontWeight:700 }} > {this.dictionary.pontaje.calendarPontaj}</h5>
                                </Grid>

                                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'center', fontWeight: 400 }} >
                                        <i className='material-icons' style={{ verticalAlign: 'middle', fontSize: 20 }}>today</i>
                                        {this.u.dataFullPlusDay(new Date())}</h5>
                                </Grid>

                                <Grid style={{ textAlign: 'right' }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ marginTop: 20, textAlign: 'right' }} className='monthcalendar-header'>
                                        <i onClick={this.minusLuna} className='material-icons' style={{ verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>keyboard_arrow_left</i>
                                        <span style={{ fontSize: 16, verticalAlign: 'text-bottom', textTransform: 'uppercase' }} className='monthcalendar-title'>
                                            {this.numeLuna(new Date(this.state.dataStart).getMonth() + 1)} {new Date(this.state.dataStart).getFullYear()}

                                        </span>
                                        <i onClick={this.plusLuna} className='material-icons' style={{ verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>keyboard_arrow_right</i>
                                    </div>
                                </Grid>


                                <Grid style={{ textAlign: 'left', margin: '20px 0 20px 0', maxHeight: 450 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    {this.afisareTabel()}

                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, }}>
                                <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.pontaje.legenda}</h5>
                                </Grid>
                                <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                    {this.state.tipConcedii &&
                                        <div style={{ textAlign: 'left', marginTop: 10, width: '95%', margin: '0 auto', maxWidth: 1300 }}>
                                            <div style={{ display: 'inline-block', marginLeft: 10, marginTop: 10 }}>
                                                <div style={{ backgroundColor: 'rgb(135	226	167)', verticalAlign: 'middle', borderRadius: 10, height: 12, width: 12, marginRight: 5 }} className='pm-task-legend'></div>
                                                <span style={{ fontSize: 12 }}>{this.dictionary.pontaje.prezent}</span>
                                            </div>

                                            {this.state.tipConcedii.map((c, idx) => {
                                                return (
                                                    <div key={idx} style={{ display: 'inline-block', marginLeft: 10, marginTop: 10 }}>
                                                        <div style={{ backgroundColor: c.bkColor, verticalAlign: 'middle', borderRadius: 10, height: 12, width: 12, marginRight: 5 }} className='pm-task-legend'></div>
                                                        <span style={{ fontSize: 12 }}>{c.nume}</span>
                                                    </div>
                                                )
                                            })}



                                        </div>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                }


                {this.props.foaieColectiva &&
                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <FoaieColectiva
                                        dataStart={this.state.dataStart}
                                        angajati={this.state.listaAngajati}
                                        minusLuna={this.minusLuna}
                                        plusLuna={this.plusLuna}
                                        pontajeAll={this.state.pontajeAll}
                                        departament={this.state.departament}
                                        tipConcedii={this.state.tipConcedii}
                                        concedii={this.state.concedii}
                                        departamente={this.state.departamente}
                                    />
                                </Grid>

                            </Grid>

                        </Grid>
                    </Grid>

                }





            </div>

        );
    }
}